import React from "react";
import "../Footer/_footer.scss";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-auto">
            Copyright undangresepsi- All Rights Reserved
          </div>
          <div className="col-12 col-md-auto">undangresepsi.online</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
